import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { BaseVisualizacaoSubCadastro, BaseVisualizacaoSubCadastroService, DataTablesService } from '../../../core';

import { PessoaEndereco } from './pessoa-endereco';
import { PessoaEnderecoFormComponent } from './form';

@Component({
    selector: 'sgt-pessoa-endereco',
    templateUrl: './pessoa-endereco.component.html',
    styleUrls: ['./pessoa-endereco.component.less']
})
export class PessoaEnderecoComponent implements BaseVisualizacaoSubCadastro<PessoaEndereco>, OnInit {
    dataTable: any;
    isFormOpen: boolean;

    @Input() entities: PessoaEndereco[];
    @ViewChild('form') form: PessoaEnderecoFormComponent;

    constructor(private baseVisualizacaoSubCadastroService: BaseVisualizacaoSubCadastroService,
                private dataTablesService: DataTablesService) { }

    ngOnInit() {
        this.showTable();
    }

    openForm() {
        this.baseVisualizacaoSubCadastroService.openForm(this);
    }

    closeForm() {
        this.baseVisualizacaoSubCadastroService.closeForm(this);
    }

    showTable() {
        this.dataTablesService.showTable('#tablePessoaEnderecos', this.dataTable)
            .then(dataTable => this.dataTable = dataTable);
    }

    insert() {
        this.baseVisualizacaoSubCadastroService.insert(this);
    }

    edit(index: number) {
        this.baseVisualizacaoSubCadastroService.edit(this, index);
    }

    delete(index: number) {
        this.baseVisualizacaoSubCadastroService.delete(this, index, this.entities, 'Deseja realmente excluir esse endereço?')
            .then(() => {})
            .catch(() => {});
    }

    onFormSave(entity: PessoaEndereco) {
        this.closeForm();
    }

    onFormCancel() {
        this.closeForm();
    }
}
